"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.radioOverrides = void 0;
var _styles = require("@mui/material/styles");
var radioOverrides = {
  MuiRadio: {
    defaultProps: {
      color: 'secondary',
      size: 'small'
    },
    styleOverrides: {
      root: function root(_ref) {
        var _ref$theme = _ref.theme,
          palette = _ref$theme.palette,
          spacing = _ref$theme.spacing;
        return {
          // .MuiRadio-root
          padding: spacing(0.25),
          '&:hover': {
            backgroundColor: (0, _styles.alpha)(palette.grey['1000'], palette.action.hoverOpacity)
          },
          '&.Mui-focusVisible': {
            backgroundColor: (0, _styles.alpha)(palette.grey['1000'], palette.action.focusOpacity)
          },
          '&:active': {
            backgroundColor: (0, _styles.alpha)(palette.grey['1000'], palette.action.activatedOpacity)
          },
          '&.Mui-disabled': {
            color: palette.action.disabled
          },
          '.MuiSvgIcon-fontSizeSmall': {
            fontSize: 16
          }
        };
      }
    }
  }
};
exports.radioOverrides = radioOverrides;